import React from "react";
import {
  getArchivedChats,
  getMutedChats,
} from "../../../Helpers/Chat/ChatHelper";
import { DEFAULT_TITLE_NAME } from "../../../Helpers/Chat/Constant";

export const Title = (props = {}) => {
  const { unreadCountData: { unreadDataObj = {} } = {} } = props;
  const [titleState, setTitleState] = React.useState({
    count: 0,
    defaultTitle: DEFAULT_TITLE_NAME,
  });
  const { count, defaultTitle } = titleState;

const handleUnreadCount = () => {
    const mutedChats = getMutedChats(),
      archivedChats = getArchivedChats();
    const disabledChats = [...mutedChats, ...archivedChats];
    const unReadUserArr = Object.keys(unreadDataObj).filter(
      (n) => !disabledChats.includes(n)
    );

    if (count !== unReadUserArr.length) {
      setTitleState(
        {
          ...titleState,
          count: unReadUserArr.length,
        }
      );
    }
  };

  React.useEffect(() => {
    handleUnreadCount();
  }, []);

  React.useEffect(() => {
    handleUnreadCount();
  }, [count, defaultTitle]);

  const notifyCount = count ? `(${count}) ${defaultTitle}` : defaultTitle;
  document.title = notifyCount;
  return true;
};


